import dagre from "@dagrejs/dagre";
import { Edge, Node } from "reactflow";
import { GraphDirection, Layout } from "../models/common";

const dagreGraph = new dagre.graphlib.Graph();
dagreGraph.setDefaultEdgeLabel(() => ({}));

export const getLayoutedElements = (
    nodes: Node[],
    edges: Edge[],
    direction = GraphDirection.Horizontal
) => {
    const WIDTH_SPACE = 40;
    const isHorizontal = direction === GraphDirection.Horizontal;
    dagreGraph.setGraph({ rankdir: direction });

    nodes.forEach((node: Node) => {
        const nodeElement = document.querySelector<HTMLDivElement>(
            `div[data-id="${node.id}"]`
        );
        dagreGraph.setNode(node.id, {
            width: (nodeElement?.offsetWidth ?? 0) + WIDTH_SPACE,
            height: nodeElement?.offsetHeight ?? 0,
        });
    });

    edges.forEach((edge: Edge) => {
        dagreGraph.setEdge(edge.source, edge.target);
    });

    dagre.layout(dagreGraph);

    nodes.forEach((node: Node) => {
        const nodeElement = document.querySelector<HTMLDivElement>(
            `div[data-id="${node.id}"]`
        );
        const nodeWithPosition = dagreGraph.node(node.id);
        node.data.layout = isHorizontal ? Layout.Horizontal : Layout.Vertical;

        node.position = {
            x:
                nodeWithPosition.x -
                ((nodeElement?.offsetWidth ?? 0) + WIDTH_SPACE) / 2,
            y: nodeWithPosition.y - (nodeElement?.offsetHeight ?? 0) / 2,
        };

        return node;
    });

    return { nodes, edges };
};
